// Static API service using mock data
import {
  mockServices,
  mockPortfolio,
  mockTeam,
  mockTestimonials,
  mockCompanyStats,
  mockContactInfo,
  mockProducts,
  mockUseCases,
  mockIndustries
} from '../mock';

// Helper function to simulate API delay for realistic UX
const delay = (ms = 300) => new Promise(resolve => setTimeout(resolve, ms));

// API functions using static data
export const apiService = {
  // Contact form submission (static version - just simulates success)
  submitContactForm: async (formData) => {
    await delay(800);
    console.log('Contact form submitted (static mode):', formData);
    return {
      success: true,
      message: "Thank you for your message! We'll get back to you within 24 hours."
    };
  },

  // Newsletter subscription (static version - just simulates success)
  subscribeNewsletter: async (email) => {
    await delay(500);
    console.log('Newsletter subscription (static mode):', email);
    return {
      success: true,
      message: 'Successfully subscribed to newsletter!'
    };
  },

  // Get services
  getServices: async () => {
    await delay(200);
    return mockServices;
  },

  // Get portfolio projects
  getPortfolio: async () => {
    await delay(200);
    return mockPortfolio;
  },

  // Get team members
  getTeam: async () => {
    await delay(200);
    return mockTeam;
  },

  // Get testimonials
  getTestimonials: async () => {
    await delay(200);
    return mockTestimonials;
  },

  // Get company stats
  getCompanyStats: async () => {
    await delay(200);
    return mockCompanyStats;
  },

  // Get contact info
  getContactInfo: async () => {
    await delay(200);
    return mockContactInfo;
  },

  // Get products
  getProducts: async () => {
    await delay(200);
    return mockProducts;
  },

  // Get use cases
  getUseCases: async () => {
    await delay(200);
    return mockUseCases;
  },

  // Get industries
  getIndustries: async () => {
    await delay(200);
    return mockIndustries;
  },
};

export default apiService;